<template>
  <el-tree
  :class="['dashboard-tree', 'tree-w-stroke', isEditMode ? 'tree-editor' : '']"
  :ref="treeRef"
  :data="treeData"
  :props="defaultProps"
  :node-key="defaultProps.treeKey"
  :filter-node-method="filterNode"
  highlight-current
  :expand-on-click-node="false"
  :default-expand-all="isExpandAll"
  :draggable="isEditMode"
  :allow-drop="allowDrop"
  :allow-drag="allowDrag"
  @node-drop="handleNodeDrop"
  @node-click="clickNode">
  <span class="el-tree-node__label" slot-scope="{ node, data }" :style="nodeLabelStyle(data.itemLevel)">
    <span v-if="!isEditMode">
      <span>{{data.label}}</span>
    </span>
    <span v-else-if="data.itemLevel === 'GROUP'" style="margin-left:-3px;">
      <span class="tree-node-edit-icon" v-show="data.defaultFlag ==='N'" @click="addDashboard($event, node, data)">
        <i class="fas fa-plus-circle"></i>
      </span>
      <span class="tree-node-edit-icon" v-show="data.defaultFlag ==='N'" @click="removeDashboardGroup($event, node, data)">
        <i class="fas fa-minus-circle"></i>
      </span>
      <span>{{data.label}}</span>
    </span>
    <span v-else-if="data.itemLevel === 'NODE'">
      <span class="tree-node-edit-icon mini" v-show="data.defaultFlag ==='N'" @click="removeDashboard($event, node, data)">
        <i class="far fa-minus-circle"></i>
      </span>
      <span>{{data.label}}</span>
    </span>
    <span v-else>
      <span>{{data.label}}</span>
    </span>
  </span>
  </el-tree>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import orderBy from 'lodash/orderBy';
import map from 'lodash/map';
import forEach from 'lodash/forEach';


import DashboardAPI from '@/api/dashboard/common';

import { rootNode, treeType, TREE_TYPE_DELIMETER } from '@/constants/tree';
import DashboardConst from '@/constants/dashboard';

import msgUtil from '@/utils/message';

import RouterTree from '@/mixins/router/tree';
import TreeFilter from '@/mixins/tree/filter';

export default {
  name: 'WDashboardTree',
  components: {
  },
  mixins: [RouterTree, TreeFilter],
  props: {
    dashboardType: {
      type: String,
      default: DashboardConst.DASHBOARD_TYPE.GRID,
    },
    treeTypes: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      treeRef: `${this.dashboardType}Tree`,
      treeType: this.dashboardType === DashboardConst.DASHBOARD_TYPE.GRID ? treeType.GRID_DASHBOARD : treeType.COORD_DASHBOARD,
      treeTypesInMenu: this.treeTypes,
      isExpandAll: true,
      defaultProps: {
        treeKey: 'treeKey',
        children: 'children',
        label: 'label',
      },
      existDashboardNode: false,
    };
  },
  computed: {
    nodeLabelStyle() {
      return (itemLevel) => ({
        cursor: !this.isEditMode && itemLevel === 'GROUP' ? 'default' : 'inherit',
      });
    },
    /**
     * 트리 편집 모드 여부 반환
     * @author KangBonghun(toto1323)
     * @return {Boolean} [description]
     */
    isEditMode() {
      return this.viewMode === DashboardConst.VIEW_MODE.TREE_EDIT;
    },
    viewMode() {
      return this.$store.getters.getDashboardViewMode;
    },
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.TREE_LOAD, this.loadData);

    this.loadData();
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.TREE_LOAD, this.loadData);
  },
  methods: {
    /**
     * 대시보드 그룹 수정
     * @author KangBonghun(toto1323)
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    editDashboardGroup(data) {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.DASHBOARD_GRP_SET, DashboardConst.SET_TYPE.EDIT, data);
    },
    /**
     * 대시보드 그룹 삭제
     * @author KangBonghun(toto1323)
     * @param  {[type]} evt  [description]
     * @param  {[type]} node [description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    removeDashboardGroup(evt, node, data) {
      this.removeDashboard(evt, node, data);
    },
    /**
     * 대시보드 추가
     * @author KangBonghun(toto1323)
     * @param  {[type]} evt  [description]
     * @param  {[type]} node [description]
     * @param  {[type]} data [description]
     */
    addDashboard(evt, node, data) {
      evt.stopPropagation();

      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.DASHBOARD_SET, DashboardConst.SET_TYPE.ADD, data);
    },
    /**
     * 대시보드 수정
     * @author KangBonghun(toto1323)
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    editDashboard(data) {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.DASHBOARD_SET, DashboardConst.SET_TYPE.EDIT, data);
    },
    /**
      * 대시보드 삭제
      * @author KangBonghun(toto1323)
      * @param  {[type]} evt  [description]
      * @param  {[type]} node [description]
      * @param  {[type]} data [description]
      * @return {[type]}      [description]
      */
    removeDashboard(evt, node) {
      evt.stopPropagation();

      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE))
        .then(() => {
          this.$refs[this.treeRef].remove(node);
        })
        .catch(() => {});
    },
    /**
     * 대시보드 트리 로드
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    loadData() {
      DashboardAPI.getDashboardTree(this.dashboardType).then((response) => {
        const result = response.data;

        if (result.success) {
          this.treeData = result.data;

          this.$store.commit('setDashboardTree', { dashboardTree: this.treeData, dashboardType: this.dashboardType });
          // this.$store.commit('setSelectedNode', {});
        }
      });
    },
    /**
     * 노드 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} nodeData [description]
     */
    clickNode(nodeData) {
      if (this.isEditMode) { // 트리 편집 모드일때
        if (nodeData.itemLevel === 'GROUP' && nodeData.defaultFlag === 'N') {
          this.editDashboardGroup(nodeData);
        } else if (nodeData.itemLevel !== 'GROUP') {
          this.editDashboard(nodeData);
        }
      } else if (nodeData.itemLevel !== 'GROUP') { // 그룹을 클릭하면 무시한다
        this.routeByTreeKey(this.concatTreeTypeAndTreeKey(nodeData[this.defaultProps.treeKey]));
      }
    },
    /**
     * 트리노드 드랍 허용 조건
     * @author JungJioon(ryunnnne)
     * @param  {[type]} draggingNode [description]
     * @param  {[type]} droppedNode  [description]
     * @param  {[type]} dropType     [description]
     * @return {[type]}              [description]
     */
    allowDrop(draggingNode, droppedNode, dropType) {
      /* eslint-disable no-lonely-if */

      // inner type 은 허용하지 않는다.
      if (dropType === 'inner') {
        return false;
      }

      // 기본 대시보드
      if (draggingNode.data.defaultFlag === 'Y') {
        // 그룹
        if (draggingNode.level === 1) {
          // 그룹끼리만 정렬 가능
          if (droppedNode.level === 1) {
            return true;
          }
          return false;
        // 노드
        } else if (draggingNode.level === 2) {
          // 기본 대시보드 그룹 안에서만 정렬 가능
          if (droppedNode.data.defaultFlag === 'Y' && droppedNode.level === 2) {
            return true;
          }
          return false;
        }

      // 사용자 대시보드
      } else {
        // 그룹
        if (draggingNode.level === 1) {
          // 그룹끼리만 정렬 가능
          if (droppedNode.level === 1) {
            return true;
          }
          return false;
        // 노드
        } else if (draggingNode.level === 2) {
          // 사용자 대시보드 그룹끼리만 정렬 가능
          if (droppedNode.data.defaultFlag !== 'Y' && droppedNode.level === 2) {
            return true;
          }
          return false;
        }
      }

      return false;
      /* eslint-enable no-lonely-if */
    },
    /**
     * 트리노드 드래그 허용 조건
     * @author JungJioon(ryunnnne)
     * @return {[type]}              [description]
     */
    allowDrag(draggingNode) {
      // 모든 노드 드래그 허용
      return true;
    },
    /**
     * 트리 노드 드랍시 그룹아이디 정렬 처리
     * @author JungJioon(ryunnnne)
     * @param  {[type]} draggingNode [description]
     * @param  {[type]} droppedNode  [description]
     * @return {[type]}              [description]
     */
    handleNodeDrop(draggingNode, droppedNode) {
      if (!draggingNode.data.leaf) {
        const orderIds = orderBy(map(this.treeData, (node) => node.dashboardGroupId));
        forEach(this.treeData, (group, idx) => {
          group.dashboardGroupId = orderIds[idx];

          forEach(group.children, (child) => {
            child.dashboardGroupId = group.dashboardGroupId;
          });
        });
      } else {
        draggingNode.data.dashboardGroupId = droppedNode.data.dashboardGroupId;
      }
    },
    /**
     * 유효한 노드인지 확인한다. (선택 가능한 노드)
     * @author Ju
     * @param  {[type]}  node [description]
     * @return {Boolean}      [description]
     */
    isValidNode(node) {
      return !isEmpty(node) && node.data.itemLevel !== 'GROUP';
    },
    /**
     * TreeData 변경 감지 후 트리 라우터 처리 전 핸들러
     * @author Ju
     */
    handlerForChangeTreeDataBeforeRoute(treeData) {
      if (this.treeType === treeType.GRID_DASHBOARD && !isEmpty(treeData)) {
        this.existDashboardNode = this.checkExistDashboardNode(treeData);
      }
    },
    /**
     * 대시보드 노드가 있는지 확인한다.
     * 있으면 true / 없으면 false를 반환한다.
     * @author Ju
     * @param  {Array} nodeDatas 트리 데이터 배열
     * @return {Boolean}
     */
    checkExistDashboardNode(nodeDatas) {
      for (let i = 0; i <= nodeDatas.length - 1; i += 1) {
        const nodeData = nodeDatas[i];
        if (nodeData.itemLevel === 'NODE') {
          return true;
        } else if (!isEmpty(nodeData.children)) {
          return this.checkExistDashboardNode(nodeData.children);
        }
      }
      return false;
    },
    /**
     * 기본적으로 선택될 노드의 treeKey를 반환한다.
     * @author Ju
     * @return {String} treeKey
     */
    getDefaultRouteTreeKey() {
      if (this.treeType === treeType.GRID_DASHBOARD && !this.existDashboardNode) { // 그리드 대시보드에 대시보드가 없는 경우 좌표 대시보드로 리다이렉트 시킨다.
        return `${treeType.COORD_DASHBOARD}${TREE_TYPE_DELIMETER}${rootNode.treeKey}`;
      }
      if (isEmpty(this.treeData)) {
        return rootNode.treeKey;
      }
      const group = find(this.treeData, (item) => item.children && item.children.length > 0);
      return this.concatTreeTypeAndTreeKey(isEmpty(group) ? rootNode.treeKey : group.children[0].treeKey);
    },
  },
};
</script>

<style lang="scss">
.dashboard-tree {
  .el-tree-node__children .is-leaf + .el-tree-node__label {
    line-height: 16px !important;
    color: #777;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/frame/DashboardTree.vue